import i18n from "i18next";
import { colorStyling } from "../../helpers/color";
import { MUIAdminIcon } from "icons/AdminIcon";
import { MUIAnnouncementIcon } from "icons/AnnouncementIcon";
import { MUIClockMediaIcon } from "icons/ClockMediaIcon";
import { MUICompanyIcon } from "icons/CompanyIcon";
import { MUIDashboardIcon } from "icons/DashboardIcon";
import { MUIGroupIcon } from "icons/GroupIcon";
import { MUIScheduleIcon } from "icons/ScheduleIcon";
import { MUIUserManualIcon } from "icons/UserManualIcon";
import { MUIViewerIcon } from "icons/ViewerIcon";
import GroupsIcon from "@mui/icons-material/Groups";
import PermMediaIcon from "@mui/icons-material/PermMedia";
import BackupTableIcon from "@mui/icons-material/BackupTable";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import AssessmentIcon from "@mui/icons-material/Assessment";
import Role from "../../helpers/roles";
const tCommon = i18n.getFixedT(null, "common");

export const sidebarMenuConfigTop = [
  {
    path: "/dashboard",
    getIcon: MUIDashboardIcon(),
    iconProps: {},
    label: tCommon("sidebar.Dashboard"),
    condition: (_, userRole) => userRole !== Role.Eins,
  },
  {
    flag: "SCREEN_GROUP",
    path: "/groups",
    pathInclude: "/group/",
    getIcon: MUIGroupIcon(),
    iconProps: {},
    label: tCommon("sidebar.Group"),
    condition: (userPermission, userRole) =>
      userPermission?.screenGroup?.read && userRole !== Role.Eins,
  },
  {
    flag: "SCREEN",
    path: "/viewers",
    pathInclude: "/viewer/",
    getIcon: MUIViewerIcon(),
    iconProps: {},
    label: tCommon("sidebar.Viewer"),
    condition: (userPermission, userRole) =>
      userPermission?.screen?.read || userRole === Role.Eins,
  },
  {
    flag: "SCHEDULE",
    path: "/schedules",
    pathInclude: "/schedule/",
    getIcon: MUIScheduleIcon({
      colorI: colorStyling.orange,
      colorII: colorStyling.yellow,
    }),
    iconProps: {},
    label: tCommon("sidebar.StandardSchedule"),
    condition: (userPermission, userRole, features) =>
      userPermission?.schedule?.read &&
      userRole !== Role.Eins &&
      (features["SCHEDULE.COMMAND"] || features["SCHEDULE.CONTENT"]),
  },
  {
    flag: "ADVERTISEMENT",
    path: "/rotating-schedules",
    pathInclude: "/rotating-schedule/",
    getIcon: MUIClockMediaIcon({ color: colorStyling.orange }),
    label: tCommon("sidebar.RotatingSchedule"),
    condition: (userPermission, userRole) =>
      userPermission?.schedule?.read && userRole !== Role.Eins,
  },
  {
    flag: "ANNOUNCEMENT",
    path: "/announcements",
    pathInclude: "/announcement/",
    getIcon: MUIAnnouncementIcon(),
    iconProps: { style: { width: 24 } },
    label: tCommon("sidebar.Announcement"),
    condition: (userPermission, userRole) =>
      userPermission?.schedule?.read && userRole !== Role.Eins,
  },
  {
    flag: "ASSET",
    path: "/cms/assets",
    icon: (
      <PermMediaIcon fontSize="medium" sx={{ color: colorStyling.orange }} />
    ),
    iconProps: {},
    label: tCommon("sidebar.AssetsManager"),
    condition: (userPermission, userRole) =>
      userPermission?.content?.read && userRole !== Role.Eins,
  },
  {
    flag: "CONTENT",
    path: "/cms/content-template",
    pathInclude: "content-template/",
    icon: (
      <BackupTableIcon fontSize="medium" sx={{ color: colorStyling.orange }} />
    ),
    iconProps: {},
    label: tCommon("sidebar.ContentTemplate"),
    condition: (userPermission, userRole) =>
      userPermission?.content?.read && userRole !== Role.Eins,
  },
  {
    flag: "LOG.CONTENT",
    path: "/report/content",
    icon: (
      <AssessmentIcon fontSize="medium" sx={{ color: colorStyling.orange }} />
    ),
    iconProps: {},
    label: tCommon("sidebar.ContentReport"),
    condition: (userPermission, userRole) =>
      userPermission?.assetLog?.read && userRole !== Role.Eins,
  },
];

export const sidebarMenuConfigBottom = [
  {
    flag: "USER",
    path: "/users",
    getIcon: MUIAdminIcon(),
    iconProps: {},
    label: tCommon("sidebar.User"),
    condition: (userPermission, userRole) =>
      userPermission?.user?.read || userRole !== Role.User,
  },
  {
    flag: "USER_GROUP",
    path: "/user/groups",
    icon: <GroupsIcon sx={{ color: colorStyling.orange }} />,
    iconProps: {},
    label: tCommon("sidebar.UserGroup"),
    condition: (userPermission, userRole) =>
      userPermission?.userGroup?.read || userRole !== Role.User,
  },
  {
    flag: "LOG.AUDIT",
    path: "/audit-log",
    icon: <TextSnippetIcon sx={{ color: colorStyling.orange }} />,
    iconProps: {},
    label: tCommon("sidebar.AuditLog"),
    condition: (userPermission, userRole) =>
      userPermission?.auditLog?.read || userRole === Role.Eins,
  },
  {
    path: "/organizations",
    getIcon: MUICompanyIcon(),
    iconProps: {},
    label: tCommon("sidebar.Organization"),
    condition: (_, userRole) => userRole === Role.Eins,
  },
  {
    flag: "MANUAL",
    path: "/manual",
    getIcon: MUIUserManualIcon(),
    iconProps: {},
    label: tCommon("sidebar.UserManual"),
    condition: (_, userRole) => userRole !== Role.Eins,
  },
];
